
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/novinky/[path]",
      function () {
        return require("private-next-pages/novinky/[path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/novinky/[path]"])
      });
    }
  